import React, { useState, useEffect } from 'react';
import { Product, ProductFormData } from '../types';
import { api } from '../services/api';
import Introduction from './Introduction';
import ProductList from './ProductList';
import ProductModal from './ProductModal';
import SuccessModal from './SuccessModal';

const Home: React.FC = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successProductName, setSuccessProductName] = useState<string>('');

    useEffect(() => {
        loadProducts();
    }, []);

    const loadProducts = async () => {
        try {
            setIsLoading(true);
            const data = await api.getProducts();
            // Ordenar produtos alfabeticamente por nome
            const sortedData = [...data].sort((a, b) =>
                a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
            );
            setProducts(sortedData);
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            alert('Erro ao carregar produtos. Tente novamente mais tarde.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelectProduct = (product: Product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    const handleConfirmSelection = async (formData: ProductFormData) => {
        if (!selectedProduct) return;

        await api.updateProduct(selectedProduct.id, formData);
        await loadProducts();

        // Mostrar modal de sucesso após salvar
        setSuccessProductName(selectedProduct.nome);
        setShowSuccess(true);
    };

    const handleSuccessClose = () => {
        setShowSuccess(false);
        setSuccessProductName('');
    };

    return (
        <div className="min-h-screen bg-gradient-primary">
            <div className="container mx-auto py-8 px-4">

                <Introduction />
                <ProductList
                    products={products}
                    onSelectProduct={handleSelectProduct}
                    isLoading={isLoading}
                />
            </div>

            <ProductModal
                product={selectedProduct}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmSelection}
            />

            <SuccessModal
                isOpen={showSuccess}
                productName={successProductName}
                onClose={handleSuccessClose}
            />
        </div>
    );
};

export default Home;
